import React, { FC } from "react";
import { StaticImage } from "gatsby-plugin-image";

interface SectionTitleProps {
  highlight: string;
  section: string;
}

const SectionTitle: FC<SectionTitleProps> = ({ highlight, section }) => {
  return (
    <div className="flex flex-col items-start my-10">
      <div className="flex items-center justify-between">
        <StaticImage
          src="../images/line.png"
          alt="Line"
          layout="constrained"
          placeholder="tracedSVG"
          className="w-16 object-contain "
        />
        <h2 className="text-base font-custom uppercase text-primary">
          {highlight}
        </h2>
      </div>
      <h6 className="font-custom font-medium text-3xl uppercase text-primary">
        {section}
      </h6>
    </div>
  );
};

export default SectionTitle;
